const FONTS = {
    InterMedium: 'InterMedium',
    InterBold: 'InterBold',
    InterRegular: 'InterRegular',
    InterSemiBold: 'InterSemiBold',
    InterLight: 'InterLight',
    Inter28ExtraLight: 'Inter28ExtraLight',
    Inter28LightItalic: 'Inter28LightItalic',
    Inter28Light: 'Inter28Light',
    Inter28MediumItalic: 'Inter28MediumItalic',
    Inter28SemiBold: 'Inter28SemiBold',
    Inter28SemiBoldItalic: 'Inter28SemiBoldItalic',
    Inter28BoldItalic: 'Inter28BoldItalic',
    Inter28ExtraBold: 'Inter28ExtraBold',
    Inter24Bold: 'Inter24Bold',
    Inter24SemiBold: 'Inter24SemiBold',
    Inter24Medium: 'Inter24Medium',
    Inter18Light: 'Inter18Light',
    Inter18Italic: 'Inter18Italic',
    Inter18Medium: 'Inter18Medium',
    Jazzier: 'jazzier',
    Lubaline: 'lubaline',
    Kozuka: 'kozuka-gothic-pr6n',
    Ryo: 'ryo-display-plusn',
    Corsario: 'corsario-variable',
    AdobeJenson: 'adobe-jenson-pro',
};

export default FONTS;